import * as React from 'react';

export const ComponentReturningChildren: React.FunctionComponent<{
  className?: string;
}> = ({ children, className }) => <div className={className}>{children}</div>;
